module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med engelsk_sentrert logo_neg(hvit).47a5febf.png";